import React from 'react';

export interface CardMetadataItem {
  label: string;
  value: React.ReactNode;
}

interface CardMetadataProps {
  items: CardMetadataItem[];
  className?: string;
}

const CardMetadata: React.FC<CardMetadataProps> = ({ items, className = '' }) => {
  const visibleItems = items.filter((item) => item.value !== undefined && item.value !== null && item.value !== '');

  if (visibleItems.length === 0) return null;

  return (
    <dl
      className={`catalog-card__meta grid mb-4 ${visibleItems.length > 1 ? 'grid-cols-2' : 'grid-cols-1'} ${className}`}
    >
      {visibleItems.map((item) => (
        <div className="catalog-card__meta-item" key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default CardMetadata;
